module.exports = __webpack_public_path__ + "static/media/Illus-Sprout.694aa389.png";